<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div><img src="/static\images\ja\newManual\changeInfoManual-1.png" alt="" /></div>
                <div>
                    <p>① 画面の右上にあるプロフィール画像にマウスを置くと、プルダウンメニューが表示されます。「個人設定」メニューをクリックします。</p>
                </div>
                <div><img src="/static\images\ja\newManual\changeInfoManual-2.png" alt="" /></div>
                <div>
                    <p>② 個人情報の編集画面に遷移し。「個人設定」タブにある個人情報詳細が初期表示されています。</p>
                    <p>③ 編集する場合は、画面右下の「編集」ボタンを押下して下さい。</p>
                </div>
                <div><img src="/static\images\ja\newManual\changeInfoManual-3.png" alt="" /></div>
                <div>
                    <p>④ 個人情報を編集します。</p>
                    <p>⑤ 「保存」ボタンを押下し、編集した最新の個人情報を更新します。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <h1>Mobile</h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/changeInfo_manual.vue